import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { EMPTY_LIST, EMPTY_OBJECT } from '../../../../constants/common'
import { getItemsIds } from '../../../../utils/common'
import { EpostForm, EpostFormProvider } from '../../../Epost'
import Text from '../../../Text'
import {
  useDocFlowContext,
  useDocFlowSendingContext,
} from '../../DocFlow.hooks'
import { DocFlowEpostValidationErrorsReportButton } from '../../DocFlowEpostValidationErrorsReportButton'
import { DocFlowSendingWidgetProcessFieldName } from '../DocFlowSending.constants'
import { DocFlowSendingEpostValidationErrorsReportModal } from '../DocFlowSendingEpostValidationErrorsReportModal'
import { DocFlowSendingValidationErrorsUserAsyncMultiValuedList } from '../DocFlowSendingValidationErrorsUserAsyncMultiValuedList'
import { DocFlowSendingWidgetContent } from '../DocFlowSendingWidgetContent'

import {
  getDocFlowSendingEpostContentInitialValues,
  toPreparedUserValue,
} from './DocFlowSendingEpostContent.utils'

import * as styles from './DocFlowSendingEpostContent.module.css'

function DocFlowSendingEpostContent() {
  const { t } = useTranslation()

  const { phaseDisabled } = useDocFlowContext()

  const {
    calculatingData,
    epostFormikRef,
    epostSettings,
    epostSupportModalData,
    handleUpdateEpostSettings,
    isCalculated,
    isCalculating,
    isEpostSettingsLoading,
    processData,
  } = useDocFlowSendingContext()

  const [modal, setModal] = useState(null)

  const {
    loading,
    validation_errors_stats: validationErrorsStats = EMPTY_LIST,
  } = epostSettings || EMPTY_OBJECT

  const errorIds = getItemsIds(validationErrorsStats, 'code')

  const initialValues = epostSettings
    ? getDocFlowSendingEpostContentInitialValues(epostSettings, t)
    : null

  const noSettings =
    processData?.[DocFlowSendingWidgetProcessFieldName.IsEpostDisabledForAll]

  function handleCloseModal() {
    setModal(false)
  }

  function handleClickOpenErrorReport() {
    setModal(
      <DocFlowSendingEpostValidationErrorsReportModal
        errorIds={errorIds}
        onClose={handleCloseModal}
      />
    )
  }

  return (
    <DocFlowSendingWidgetContent
      {...(noSettings ? { Title: null } : null)}
      className={noSettings ? styles.noSettings : styles.content}
      title={t('DocFlow.EpostSettingsTitleKey')}
    >
      {noSettings ? (
        <Text isSecondary>{t('DocFlow.EpostSettingsNoSettingsTextKey')}</Text>
      ) : (
        <EpostFormProvider
          calculateLoadingPercent={loading}
          calculatingData={calculatingData}
          contentProps={{
            className: styles.formContent,
            shadow: false,
          }}
          externalRef={epostFormikRef}
          handleClickSupport={epostSupportModalData.handleOpenModal}
          handleCloseSupportModal={epostSupportModalData.handleCloseModal}
          isCalculated={isCalculated}
          isCalculating={isCalculating}
          isInitiating={!epostSettings && isEpostSettingsLoading}
          isOpenSupportModal={epostSupportModalData.isOpenModal}
          readonly={phaseDisabled}
          showContent={!phaseDisabled}
          supportModalInitialValues={epostSupportModalData.initialValues}
          validationErrors={validationErrorsStats}
          validationErrorsContentProps={{
            buttonEditProps: {
              onClick: handleClickOpenErrorReport,
            },
            tableProps: {
              items: validationErrorsStats,
              rowProps: {
                TextCellAction: DocFlowEpostValidationErrorsReportButton,
                UserList:
                  DocFlowSendingValidationErrorsUserAsyncMultiValuedList,
                actionProps: {
                  text: t('DocFlow.EpostValidationErrorsOpenReportBtnKey'),
                },
                toPreparedUserValue,
                onClickTextCellAction: handleClickOpenErrorReport,
              },
            },
            text: t('DocFlow.EpostValidationErrorsTextKey'),
          }}
        >
          <EpostForm
            initialValues={initialValues}
            onSubmit={handleUpdateEpostSettings}
          />
          {modal}
        </EpostFormProvider>
      )}
    </DocFlowSendingWidgetContent>
  )
}

export default DocFlowSendingEpostContent
